export default "__VITE_ASSET__DLxBDMbK__"